import { type HTMLAttributes } from 'react'

interface LogoProps extends HTMLAttributes<SVGSVGElement> {
	variant?: 'framericons' | 'notionicons'
}

function FramerIconsLogo(props: HTMLAttributes<SVGSVGElement>) {
	return (
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.3214 19.9367L26.2781 24.8935C27.0592 25.6745 28.3255 25.6745 29.1065 24.8935L34.5858 19.4142C35.3669 18.6332 35.3669 17.3668 34.5858 16.5858L29.1065 11.1065C28.3255 10.3255 27.0592 10.3255 26.2781 11.1065L21.3213 16.0633L29.165 17.5083C29.7109 17.6088 29.7109 18.3912 29.165 18.4917L21.3214 19.9367Z"
				fill="rgb(41, 112, 255)"
			></path>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.1905 21.1942L11.1065 26.2782C10.3255 27.0592 10.3255 28.3255 11.1065 29.1066L16.5858 34.5859C17.3668 35.3669 18.6332 35.3669 19.4142 34.5859L24.8935 29.1066C25.6745 28.3255 25.6745 27.0592 24.8935 26.2782L20.0244 21.409L18.619 29.0379C18.5184 29.5838 17.7361 29.5838 17.6355 29.0379L16.1905 21.1942Z"
				fill="rgb(41, 112, 255)"
			></path>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.1065 6.8934C10.3255 7.67445 10.3255 8.94078 11.1065 9.72183L16.1905 14.8058L17.6355 6.96209C17.7361 6.4162 18.5184 6.4162 18.619 6.96209L20.0244 14.591L24.8935 9.72183C25.6745 8.94078 25.6745 7.67445 24.8935 6.8934L19.4142 1.41413C18.6332 0.633081 17.3669 0.63308 16.5858 1.41413L11.1065 6.8934Z"
				fill="rgb(41, 112, 255)"
			></path>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.41421 16.5858C0.633165 17.3668 0.633163 18.6332 1.41421 19.4142L6.89348 24.8935C7.67453 25.6745 8.94085 25.6745 9.7219 24.8935L14.7183 19.8971L7.08943 18.4917C6.54355 18.3912 6.54355 17.6088 7.08943 17.5083L14.7183 16.1029L9.7219 11.1065C8.94086 10.3255 7.67453 10.3255 6.89348 11.1065L1.41421 16.5858Z"
				fill="rgb(41, 112, 255)"
			></path>
		</svg>
	)
}

function NotionIconsLogo(props: HTMLAttributes<SVGSVGElement>) {
	return (
		<svg
			width="29"
			height="29"
			viewBox="0 0 29 29"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M14.733 2.35017L25.647 8.48927V20.7675L14.733 26.9066L3.81909 20.7675V8.48927L14.733 2.35017Z"
				fill="white"
			/>
			<path
				d="M12.2816 1.64212C13.8037 0.785959 15.6622 0.785959 17.1842 1.64212L24.9172 5.9919C26.4916 6.87749 27.4659 8.54341 27.4659 10.3498V18.9072C27.4659 20.7136 26.4916 22.3795 24.9172 23.2651L17.1842 27.6149C15.6622 28.471 13.8037 28.471 12.2816 27.6149L4.54869 23.2651C2.97431 22.3795 2 20.7136 2 18.9072V10.3498C2 8.54341 2.97431 6.87749 4.54869 5.9919L12.2816 1.64212ZM8.18668 8.11956C6.61229 9.00515 5.63798 10.6711 5.63798 12.4775V16.7795C5.63798 18.5859 6.61229 20.2518 8.18667 21.1374L12.2816 23.4408C13.8037 24.297 15.6622 24.297 17.1842 23.4408L21.2792 21.1374C22.8536 20.2518 23.8279 18.5859 23.8279 16.7795V12.4775C23.8279 10.6711 22.8536 9.00516 21.2792 8.11957L17.1842 5.81615C15.6622 4.95999 13.8037 4.95999 12.2816 5.81615L8.18668 8.11956Z"
				fill="white"
			/>
			<path
				d="M14.733 2.35017L25.647 8.48927V20.7675L14.733 26.9066L3.81909 20.7675V8.48927L14.733 2.35017Z"
				fill="white"
			/>
			<path
				d="M12.2816 2.68558C13.8036 1.82941 15.6621 1.82942 17.1842 2.68558L24.0076 6.52376C25.582 7.40936 26.5563 9.07527 26.5563 10.8817V18.3752C26.5563 20.1816 25.582 21.8475 24.0076 22.7331L17.1842 26.5713C15.6621 27.4275 13.8036 27.4275 12.2816 26.5713L5.45812 22.7331C3.88373 21.8475 2.90942 20.1816 2.90942 18.3752V10.8817C2.90942 9.07528 3.88374 7.40935 5.45812 6.52376L12.2816 2.68558ZM7.27711 7.5876C5.70272 8.47319 4.72841 10.1391 4.72841 11.9455V17.3114C4.72841 19.1178 5.70273 20.7837 7.27711 21.6693L12.2816 24.4843C13.8036 25.3404 15.6621 25.3404 17.1842 24.4843L22.1886 21.6693C23.763 20.7837 24.7373 19.1178 24.7373 17.3114V11.9455C24.7373 10.1391 23.763 8.47319 22.1886 7.5876L17.1842 4.77259C15.6621 3.91643 13.8036 3.91643 12.2816 4.77259L7.27711 7.5876Z"
				fill="#111111"
			/>
			<path
				d="M21.0973 5.95265L11.1308 11.5588L14.7327 13.5849L25 8L25.5 10L15.6422 15.1603L15.5 26.5H14L13.8232 15.1603L9.27571 12.6023L9.25977 12.6113L9.24501 12.5851L3.5 9.5L4.5 8L9.27571 10.5153L19.5 5L21.0973 5.95265Z"
				fill="#111111"
			/>
			<path
				d="M22.5823 13.2408L21.4163 13.8938V17.8873L21.3676 17.9146L18.9762 15.2603L17.9482 15.836V22.186L19.1196 21.53V17.5334L19.1602 17.5106L21.5705 20.1574L22.5823 19.5908V13.2408Z"
				fill="#111111"
			/>
		</svg>
	)
}

export default function Logo({ variant = 'framericons', ...props }: LogoProps) {
	if (variant === 'notionicons') {
		return <NotionIconsLogo {...props} />
	}
	return <FramerIconsLogo {...props} />
}
